import { useTranslation } from 'react-i18next';
import { Box } from 'src/components/Box';
import { Divider } from 'src/components/Divider';
import { Dot } from 'src/components/Dot';
import { Stack } from 'src/components/Stack';
import { Typography } from 'src/components/Typography';
import { formatTime } from 'src/utils/dateFormatter';

interface CalendarPopoverContentProps {
  event: any;
}

export const CalendarPopoverContent: React.FC<CalendarPopoverContentProps> = ({
  event,
}) => {
  const { t } = useTranslation('translation', { keyPrefix: 'schedules.calendar.popover' });

  return (
    <>
      <Box>
        <Box sx={{ p: 1, pr: 2 }}>
          <Typography variant="h5" gutterBottom>
            {event?.title}
          </Typography>

          <Typography variant="body2" color="text.secondary">
            <Dot sx={{ mr: 0.5, bgcolor: event?.textColor }} />{' '}
            {formatTime(event?.startStr)} - {formatTime(event?.endStr)}
          </Typography>
        </Box>
        <Divider sx={{ my: 0.5, mx: 1 }} />
        <Stack sx={{ p: 1, pr: 2 }} spacing={1}>
          {event.extendedProps.objectType === 'appointment' && (
            <>
              <Typography variant="body2">
                <Typography
                  variant="body2"
                  component="span"
                  color="text.secondary"
                >
                  {t('trainer')}:
                </Typography>{' '}
                {event?.extendedProps?.data.primaryTrainerName}
              </Typography>
              {event?.extendedProps?.data.location && (
                <Typography variant="body2">
                  <Typography
                    variant="body2"
                    component="span"
                    color="text.secondary"
                  >
                    {t('location')}:
                  </Typography>{' '}
                  {event?.extendedProps?.data.location}
                </Typography>
              )}
              <Typography variant="body2">
                <Typography
                  variant="body2"
                  component="span"
                  color="text.secondary"
                >
                  {t('service')}:
                </Typography>{' '}
                {event?.extendedProps?.data.service}
              </Typography>
              {event?.extendedProps?.data.resourceNames && (
                <Typography variant="body2">
                  <Typography
                    variant="body2"
                    component="span"
                    color="text.secondary"
                  >
                    {t('assets')}:
                  </Typography>{' '}
                  {event?.extendedProps?.data.resourceNames}
                </Typography>
              )}
              <Typography variant="body2">
                <Typography
                  variant="body2"
                  component="span"
                  color="text.secondary"
                >
                  {t('participants')}:
                </Typography>{' '}
                {event?.extendedProps?.data.clientsCount}
              </Typography>
              {event?.extendedProps?.data.visitsRemaining > 0 && (
                <Typography variant="body2">
                  <Typography
                    variant="body2"
                    component="span"
                    color="text.secondary"
                  >
                    {t('spotsRemaining')}:
                  </Typography>{' '}
                  {event?.extendedProps?.data.visitsRemaining}
                </Typography>
              )}
              {event?.extendedProps?.data.waitlistCount > 0 && (
                <Typography variant="body2">
                  <Typography
                    variant="body2"
                    component="span"
                    color="text.secondary"
                  >
                    {t('waitlist')}:
                  </Typography>{' '}
                  {event?.extendedProps?.data.waitlistCount}
                </Typography>
              )}
              {event?.extendedProps?.data.scheduleId && (
                <Typography variant="body2" color="text.secondary">
                  {t('createdFromSchedule')}
                </Typography>
              )}
            </>
          )}
          {event.extendedProps.objectType === 'schedule' && (
            <>
              <Typography variant="body2">
                <Typography
                  variant="body2"
                  component="span"
                  color="text.secondary"
                >
                  {t('trainer')}:
                </Typography>{' '}
                {event?.extendedProps?.data.trainerName}
              </Typography>
              {event?.extendedProps?.data.location && (
                <Typography variant="body2">
                  <Typography
                    variant="body2"
                    component="span"
                    color="text.secondary"
                  >
                    {t('location')}:
                  </Typography>{' '}
                  {event?.extendedProps?.data.location}
                </Typography>
              )}
            </>
          )}
        </Stack>
      </Box>
    </>
  );
};
